export default "__VITE_ASSET__vJpsb3Js__"